import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../../app_components/StandardModal'
import StandardButton from '../../app_components/StandardButton'
import ChatContainer from '../../chat_components/ChatContainer';
import NewLexForm from './NewLexForm'

class ChatMeetingButtons extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      chatOpen: false,
      scheduleLexOpen: false
    }
    this.toggleScheduleLex = this.toggleScheduleLex.bind(this)
    this.toggleChat = this.toggleChat.bind(this)
    this.renderChat = this.renderChat.bind(this)
    this.renderScheduleLex = this.renderScheduleLex.bind(this)
  }

  toggleScheduleLex() {
    this.setState({
      scheduleLexOpen: !this.state.scheduleLexOpen
    })
  }

  toggleChat() {
    this.setState({
      chatOpen: !this.state.chatOpen
    })
  }

  renderChat() {
    return(
      <ChatContainer
        convoId={this.props.convoId}
        missingImg={this.props.missingImg}
        closeChat={this.toggleChat}
      />
    )
  }

  renderScheduleLex() {
    return(
      <NewLexForm
        otherUserId={this.props.otherUserId}
        onClose={this.toggleScheduleLex}
      />)
  }

  render() {
    return(
      <div>
        {this.state.chatOpen && this.renderChat()}
        {this.state.scheduleLexOpen && this.renderScheduleLex()}
        <div className="profile-actions">
          <div className="profile-actions__row">
            <div className="profile-actions__col">
              <StandardButton
                primary={false}
                size="large"
                fullWidth
                text="Schedule Lex"
                onClick={() => this.toggleScheduleLex()}
              />
            </div>
            <div className="profile-actions__col">
              <StandardButton
                primary
                size="large"
                fullWidth
                text="Chat"
                onClick={() => this.toggleChat()}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default ChatMeetingButtons;
